export default __webpack_public_path__ + "static/media/notification-bell.d7b59220.svg";